import { render, staticRenderFns } from "./AddFeedTankReferencePoint.vue?vue&type=template&id=687bf57c&scoped=true&"
import script from "./AddFeedTankReferencePoint.vue?vue&type=script&lang=ts&"
export * from "./AddFeedTankReferencePoint.vue?vue&type=script&lang=ts&"
import style0 from "./AddFeedTankReferencePoint.vue?vue&type=style&index=0&id=687bf57c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687bf57c",
  null
  
)

export default component.exports